import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { isEmpty, isNull, some } from 'lodash'
import Link from 'next/link'
import { useMemo } from 'react'

import { NewIcon } from '@/shared/layout/WithCurriculumLayout/Icons'
import { checkRegister24HoursAgo } from '@/shared/utils/checkRegister24HoursAgo'

import { IMyQna } from '../../qna/types/qna'

interface IBoardQnACardProps {
  curriculumId: string
  data: IMyQna[] | undefined
}

const CurriculumQnACard = ({ curriculumId, data }: IBoardQnACardProps) => {
  const isNew = useMemo(() => {
    if (data) {
      return some(data, qna => checkRegister24HoursAgo(qna.createdAt))
    }
  }, [data])

  return (
    <>
      {isEmpty(data) ? (
        <div className="flex h-fit w-full flex-col items-center gap-4 rounded-2xl border bg-white px-5 py-6 lg:gap-5 lg:px-7 lg:py-8">
          <div className="flex w-full flex-row items-center justify-between">
            <h5 className="flex flex-row items-center gap-1 text-lg font-semibold text-label-normal md:font-bold lg:text-xl">
              Q&A
            </h5>
            <Link
              href={`/${curriculumId}/qna`}
              className="flex flex-row items-center gap-1 text-sm text-label-neutral"
            >
              자세히보기
              <ChevronRightIcon className="w-4 shrink-0 stroke-[1.34px]" />
            </Link>
          </div>
          <ul className="flex w-full flex-col">
            <li className="w-full rounded-lg bg-alternative py-4 text-center text-sm text-label-alternative">
              작성된 질문이 없어요.
            </li>
          </ul>
        </div>
      ) : (
        <div className="flex h-fit w-full flex-col items-center gap-4 rounded-2xl border bg-white px-5 py-6 lg:gap-5 lg:px-7 lg:py-8">
          <div className="flex w-full flex-row items-center justify-between">
            <h5 className="flex flex-row items-center gap-1 text-lg font-semibold text-label-normal md:font-bold lg:text-xl">
              Q&A
              {isNew && <NewIcon />}
            </h5>
            <Link
              href={`/${curriculumId}/qna`}
              className="flex flex-row items-center gap-1 text-sm text-label-neutral"
            >
              자세히보기
              <ChevronRightIcon className="w-4 shrink-0 stroke-[1.34px]" />
            </Link>
          </div>
          <ul className="flex w-full flex-col">
            {data?.map(({ id, title, answer }, idx) => {
              const isAnswered = !isNull(answer)
              return (
                <li
                  key={`curriculum_qna${idx}`}
                  className="flex cursor-pointer flex-col gap-[4.5px] border-b border-dotted py-4 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0"
                >
                  <Link href={`/${curriculumId}/qna/${id}`}>
                    <h6 className="line-clamp-1 text-base font-medium text-label-normal">
                      {title}
                    </h6>
                    <div className="flex items-center">
                      <p
                        className={`${
                          isAnswered ? 'text-primary-normal' : 'text-label-alternative'
                        } text-sm font-semibold`}
                      >
                        {isAnswered ? '답변완료' : '답변대기중'}
                      </p>
                    </div>
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </>
  )
}

export default CurriculumQnACard
